import { useState, useEffect, useRef } from "react";
import Button from "../Button";
import Text from "../../Text";

const InstallAppButton = () => {
    const [defferedPrompt, setDeferredPrompt] = useState(null);

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
        }

        window.addEventListener("beforeinstallprompt", handler);

        return () => {
            window.removeEventListener("beforeinstallprompt", handler);
        }
    }, []);

    const handleInstallClick = async () => {
        if (defferedPrompt) {
            defferedPrompt.prompt();
            setDeferredPrompt(null);
        }
    }

    if (!defferedPrompt) {
        return null;
    }

    return (
        <Button onClickAction={handleInstallClick} buttonColor="bg-blue-500" classNames="gap-1">
            <Text type="buttontext">Installiere App</Text>
        </Button>
    );
}
export default InstallAppButton;